<template>
  <img class="file-icon" :src="icon" alt="" />
</template>
<script>
import { fileSuffix } from '@/const/common.js';
import icon from '@/assets/image/fileType/index.js';
export default {
  props: {
    type: {
      type: String,
      defalut: ''
    },
    fileName: {
      type: String,
      defalut: ''
    },
    imageSrc: {
      type: String,
      defalut: ''
    }
  },
  computed: {
    // 图像逻辑 ， 优先级最高是 imageSrc 字段，可自定义图标， 次之为 type 再次之根据文件后缀来判断
    icon() {
      if (this.imageSrc) {
        return this.imageSrc;
      }
      let suffix = this.type;
      if (!suffix && this.fileName) {
        let arr = this.fileName.split('.');
        if (arr && arr.length > 0) {
          suffix = arr[arr.length - 1];
        }
      }
      let temp = fileSuffix.find(item => item.strs.includes(suffix));
      let type = 'default';
      if (temp) {
        type = temp.type;
      }
      return icon[type];
    }
  }
};
</script>
<style scoped>
.file-icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}
</style>
